import { DateUtil, isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { AbstractModel } from './abstract-model';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Person } from './person';

@inheritSerialization(AbstractModel)
export class User extends AbstractModel {
  @autoserializeAs(Person)
  person: Person;

  @autoserialize
  password: string;

  @autoserializeAs(Date)
  lastLoginDate: Date;

  @autoserialize
  active: boolean;

  @autoserialize
  deactivationReasonId: number;

  @autoserializeAs(Date)
  locationModifiedDate: Date;

  @autoserialize
  failedLoginAttempts: number;

  @autoserialize
  createdByUserId: number;

  constructor() {
    super();
    this.person = new Person();
  }

  static OnSerialized(instance: User, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.lastLoginDate)) {
      json.lastLoginDate = DateUtil.serializeDate(instance.lastLoginDate);
    }

    if (!isNullOrUndefined(instance.locationModifiedDate)) {
      json.locationModifiedDate = DateUtil.serializeDate(instance.locationModifiedDate);
    }
  }

  static OnDeserialized(instance: User, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['lastLoginDate'])) {
      instance.lastLoginDate = DateUtil.deserializeDate(json['lastLoginDate']);
    }

    if (!isNullOrUndefined(json['locationModifiedDate'])) {
      instance.locationModifiedDate = DateUtil.deserializeDate(json['locationModifiedDate']);
    }
  }
}
